// GENERATED by scripts/build-tokens.mjs from tokens/rc.tokens.json (breakpoints) — do not edit.
/** The only breakpoints, in CSS pixels. Phone < sm · tablet sm–lg (inherits) · laptop ≥ lg · wide ≥ xl. */
export const BREAKPOINTS = Object.freeze({"sm":640,"md":900,"lg":1200,"xl":1440});
export const BREAKPOINT_ORDER = Object.freeze(["sm","md","lg","xl"]);
